import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { useNavigate } from 'react-router';

import { Modal } from '../../components/Modal';
import { useProject } from '../../projects/context';
import { LeadCreateForm } from './LeadCreateForm';

// „Lead anlegen“ in der Leadliste (Terminierer, Support, Leitung): danach öffnet sich der neue Lead.
export function LeadCreateButton() {
  const { project, can } = useProject();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [open, setOpen] = useState(false);
  if (!can('lead.create')) return null;
  return (
    <>
      <button type="button" className="btn btn-primary" onClick={() => setOpen(true)}>
        Lead anlegen
      </button>
      {open && (
        <Modal title="Lead anlegen" size="wide" onClose={() => setOpen(false)}>
          <LeadCreateForm
            onCancel={() => setOpen(false)}
            onCreated={(lead) => {
              void queryClient.invalidateQueries({ queryKey: ['projects', project.id, 'leads'] });
              void navigate(`/p/${project.key}/leads/${lead.id}`);
            }}
          />
        </Modal>
      )}
    </>
  );
}
